const SMConst = {

  Display: {
    Hidden: 0,
    Loading: 1,
    Visible: 2,
    Init: 8,
    Empty: 9,
  },

  AccessoryType: {
    None: 0,
    Checked: 1,
    UnMarked: 2,
  },

  TableRowType: {
    Default: 0,
    Section: 1,
    SectionWithAddButton: 2,
  },

  ReservationUseType: {
    None: 0,
    Indivisual: 1,
    Corporate: 2,
  },

  NotificationType: {
    MessageUpdated: 3,
    ServiceMessage: 13,
    ServiceNotification: 20,
  },

  MessageType: {
    Message: 0,
    Timeline: 1,
    ServiceMessage: 2,
  },

  ReservationMediator: {
    SpaceMarket: 0,
    OwnerDirect: 1,
  },

  ReservationMethod: {
    Reservation: 0,
    Inquiry: 1,
    Block: 2,
    Concierge: 3,
  },

  PaymentMethod: {
    None: 0,
    Bank: 1,
    Card: 2,
    Onsite: 3,
    Invoice: 4,
    Postpay: 5,
    Other: 99,
  },

  CardType: {
    RegisteredCard: 1,
    OtherCard: 2,
  },

  PaymentSelect: {
    //カード
    Card: 1,
    //銀行決済
    Bank: 2,
    //銀行振込(後払い)
    Postpay: 3,
    //ビジネスアカウント
    BusinessAccount: 4,
  },

  ReservationStatus: {
    // 送信済
    Sent: 0,
    // 問い合わせベースパターン
    EntrustedOwner: 1,
    // リクエスト済
    Requested: 2,
    // 承認済
    Confirmed: 3,
    // キャンセル送信済
    CancelSent: 4,
    // キャンセル済（ゲスト起因）
    Cancelled: 5,
    // キャンセル済（ホスト起因）
    OwnerCancelled: 6,
    // リクエスト拒否
    Rejected: 7,
    // 支払い済
    Paid: 8,
    // 支払い待ち（銀行,現地決済,請求書）
    Paying: 9,
    // 払い戻し済
    Refunded: 10,
    // 現地支払い
    Onsite: 11,
    // 請求書払い
    Invoice: 12,
    // 期限切れ
    Expired: 13,
    // サービスによるキャンセル
    SystemCancelled: 14,
    // 利用済み
    Ended: 14,
    // 後払い(予約完了)
    Postpay: 15,
  },

  OwnerStatus: {
    Created: 0,
    Requested: 1,
    Confirmed: 2,
    Rejected: 9,
    Banned: 10,
  },

  Visibility: {
    Hidden: 0,
    Visible: 1,
  },

  RoomStatus: {
    Request: 0,
    Available: 1,
    Unavailable: 2,
    Full: 3,
    Disable: 4,
    Close: 5,
    Interval: 6,
    SessionPriceBlock: 7,
  },

  StayCertificationStatus: {
    NotSubmitted: 0,
    Created: 1,
    Investigating: 2,
    Declined: 3,
    Activated: 4,
  },

  CalendarType: {
    Reservation: 0,
    Availability: 1,
    HourlyPrice: 2,
    DailyPrice: 3,
    SessionPrice: 4,
    StayPrice: 5,
  },

  CalendarItemType: {
    Holiday: 0,
    Unavailability: 1,
    ExternalServiceItem: 2,
  },

  Frequency: {
    Daily: 1,
    Weekly: 2,
  },

  ScheduleType: {
    Available: 0,
    Disable: 1,
    Reservation: 10,
    Imported: 20,
  },

  UserTelDisplayType: {
    Normal: 0,
    Always: 1,
  },

  RequiredUnit: {
    Hour: 0,
    Day: 1,
    All: 2,
  },

  GoogleCalendarDirection: {
    Import: 1,
    Export: 2,
  },

  AuthorityForGoogleCalendar: {
    Unknown: 1,
    Read: 1,
    ReadAndWrite: 2,
  },

  AmenityType: {
    All: 0,
    Rental: 1,
    Stay: 2,
  },

  RentType: {
    None: 0,
    DayTime: 1,
    Stay: 2,
  },

  StayRoomType: {
    Undefined: 0,
    SharedRoom: 1,
    PrivateRoom: 2,
    EntirePlace: 3,
  },

  PriceCalcType: {
    PerRoom: 0,
    PerPerson: 1,
  },

  RoomDisplayType: {
    Normal: 0,
    InquiryOnly: 1,
  },

  AlertType: {
    None: 0,
    NgWord: 1,
  },

  CertificationStatus: {
    NotSubmitted: 0,
    Requested: 1,
    Confirmed: 2,
    Rejected: 9,
  },

  StayCertificationType: {
    // ホテル営業
    Hotel: 0,
    // 旅館営業
    Inn: 1,
    // 簡易宿所
    BudgetHotel: 2,
    // 下宿営業
    BoardingHouse: 3,
    // 民泊
    VacationRental: 4,
  },

  CouponDiscountType: {
    Percentage: 1,
    Amount: 2,
  },

  CouponType: {
    Normal: 0,
    FirstLimited: 1,
    FirstLimitedForExistingUsers: 2,
  },

  MessageClosedReasonType: {
    // ホストに直接やりとりを頼まれた
    Disintermediation: 1,
    // 利用用途に合わなかった
    Condition: 2,
    // 日程が合わなかった
    Schedule: 3,
    // 価格が合わなかった
    Price: 4,
    // その他
    Other: 5,
  },

  MessageDisableReasonType: {
    // 期限切れ
    Expired: 0,
    // ゲストが終了した
    UserClosed: 1,
  },

  OwnerRank: {
    // トップホストではない
    None: 0,
    // トップホスト
    SuperHost: 1,
  },

  OwnerEvaluation: {
    Unevaluatable: 0,
    Good: 1,
    Average: 2,
    Bad: 3,
  },

  ConciergeVia: {
    Concierge: 0,
    Inquiry: 1,
  },

  AcademyLinkDisplayPlace: {
    RoomBasic: 0,
    RoomDiscription: 1,
    RoomMedia: 2,
    RoomPlan: 3,
    RoomOption: 4,
    RoomFood: 5,
    DashboardTop: 6,
    SpaceBasic: 7,
    SpaceAddress: 8,
    SpaceText: 9,
    SpaceTerms: 10,
  },

  AcademyLinkDisplay: {
    Open: 0,
    Close: 1,
  },

  ReservationBlockType: {
    Manual: 0,
    Unavailable: 1,
  },

  TodoItemType: {
    MailAddressUnverified: 0,
    SpaceUncreated: 1,
    SpaceNotDisplayable: 2,
    RoomUncreated: 3,
    RoomNotDisplayable: 4,
    OwnerCertificateUnuploaded: 5,
    OwnerCorpInformationNotRegistered: 6,
    OwnerContactNotRegistered: 7,
    OwnerBankAccountNotRegistered: 8,
    OwnerNoReviewRequested: 9,
    ReviewPost: 10,
    OwnerReviewPost: 11,
    MessagePeriodExpired: 12,
    InputPreviewResult: 13,
    OwnerBankAccountCodeNotRegistered: 14,
    OwnerResendReviewRequest: 15,
    OwnerCardAccountUnverified: 16,
    OwnerBanned: 17,
  },

  FeatureCategoryDepth: {
    None: 0,
    LargeArea: 1,
    City: 2,
    Station: 3,
  },

  CommonHelpPageID: {
    AboutTopHost: '227088227',
  },

  OwnerHelpPageID: {
    ReservationBlock: '235216208#block',
    ManualReservation: '235216208#manual',
    RespondReservation: '236224548',
    ChangeReservation: '115008662587',
    GuestCancelRefund: '217752137#p2',
    ReservationCalendarCooperation: '235216208',
    AcceptReservationPeriod: '115008662587#howto',
    ManageVacantTime: '229651107',
    IncreaseAccess: '226765547',
    ForCorporateUse: '236249027',
    SetVariousPrice: '231885568',
  },

  UserHelpPageID: {
    ChangeReservation: '115004047428',
    ReservationOrInquiry: '218855258',
    PaymentMethod: '217748737',
    CancelReservation: '217752137',
    AboutCoupon: '115008356508',
    IssueReceipt: '217386108',
    IssueInvoice: '218429038',
    ChangeAddressee: '217748787',
  },

  // https://developers.google.com/maps/documentation/javascript/geocoding?hl=ja#GeocodingAddressTypes
  AddressComponentType: {
    Prefecture: 'administrative_area_level_1',
    Locality: 'locality',
    Sublocality: 'sublocality',
  },

  PointRate: {
    Default: 3
  },

  BillingDestinationType: {
    User: 1,
    Company: 2,
  }
};
export default SMConst;



// WEBPACK FOOTER //
// ./app/javascript/lib/SMConst.js